export const requestTiktokApi = (params: any) => {
    return fetch("/api/analysis/tiktokApi", { method: "POST", body: params });
};
